import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  RendererStyleFlags2,
  ViewChild
} from '@angular/core';

import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { UsuarioService } from 'src/app/services/usuario.service';
import { ErrorsService } from 'src/app/services/errors.service';
import { GeneralService } from 'src/app/services/general.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import { MatDialog } from '@angular/material/dialog';
import { LoginVerificationComponent } from '../login-verification/login-verification.component';

import Swal from 'sweetalert2';

import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { PageLoaderService } from 'src/app/services/page-loader.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {

  @Input() loginPaciente: boolean;
  @Input() loginMobile: boolean;

  /*
   * El LoginComponent informa al wrapper
   * los datos del error.
   */
  @Output() loginError = new EventEmitter<any>();


  @ViewChild('trigLoginLoadingModal')
  trigLoginLoadingModal: ElementRef;

  @ViewChild('trigLoginErrorModal')
  trigLoginErrorModal: ElementRef;


  public rut: string;

  public recuerdame: boolean = false;

  public name_typ_user: string;

  public id_typ_user: number;

  public fieldTextType: boolean = false;

  public domainInfo: any = {};

  public token_recaptcha: string;

  MatDialogRef: any;

  colors: any[] = [];


  private readonly DEFAULT_PRIMARY = '#0E0087';

  private readonly DEFAULT_SECONDARY = '#9e9e9e';


  constructor(
    private router: Router,
    private _usuarioSerice: UsuarioService,
    public _errors: ErrorsService,
    private renderer: Renderer2,
    private generalService: GeneralService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dialog: MatDialog,
    private encriptacionService: EncriptacionService,
    private elRef: ElementRef,
    private pageLoader: PageLoaderService
  ) { }


  ngOnInit(): void {

    const url = this.router.url;

    this.name_typ_user =
      this.loginPaciente
        ? 'PACIENTE'
        : 'MÉDICO';


    if (url === '/login') {
      this.id_typ_user = 2;

    } else if (url === '/login-doctor') {
      this.id_typ_user = 1;

    } else if (url === '/login-contact') {
      this.id_typ_user = 7;

    } else if (url === '/login-coordinador') {
      this.id_typ_user = 8;

    } else if (url === '/login-alianza') {
      this.id_typ_user = 11;

    } else if (url === '/login-admin') {
      this.id_typ_user = 12;

    } else if (url === '/login-gestion') {
      this.id_typ_user = 13;

    } else if (url === '/login-ejecutivo') {
      this.id_typ_user = 14;
    }


    sessionStorage.removeItem('token');

    sessionStorage.removeItem('usuario');


    this.observerPageInfo();


    this.generalService
      .getInfoDomain()
      .then((result) => {

        this.domainInfo = result;

        this.applyThemeFromDomain();

      })
      .catch(() => { });

  }


  // =========================================================
  // THEME
  // =========================================================

  private isValidHexColor(
    value: string
  ): boolean {

    if (!value) {
      return false;
    }

    const v = value.trim();

    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(v);
  }


  private pickColor(
    value: any,
    fallback: string
  ): string {

    const v =
      (value ?? '')
        .toString()
        .trim();

    if (!v) {
      return fallback;
    }

    if (!this.isValidHexColor(v)) {
      return fallback;
    }

    return v;
  }


  private hexToRgba(
    hex: string,
    alpha = 0.18
  ): string {

    const h =
      (hex || '')
        .replace('#', '')
        .trim();

    const full =
      h.length === 3
        ? h
          .split('')
          .map((c) => c + c)
          .join('')
        : h;


    if (full.length !== 6) {

      return `rgba(14, 0, 135, ${alpha})`;

    }


    const r =
      parseInt(
        full.substring(0, 2),
        16
      );

    const g =
      parseInt(
        full.substring(2, 4),
        16
      );

    const b =
      parseInt(
        full.substring(4, 6),
        16
      );


    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }


  private applyThemeFromDomain(): void {

    const colores =
      this.domainInfo?.colores || {};

    const coloresDefault =
      this.domainInfo?.coloresDefault || {};


    const isActive =
      colores?.is_active === true;


    const rawPrimary =
      isActive
        ? colores?.color_primary
        : coloresDefault?.color_primary;


    const rawSecondary =
      isActive
        ? colores?.color_secundary
        : coloresDefault?.color_secundary;


    const primary =
      this.pickColor(
        rawPrimary,
        this.DEFAULT_PRIMARY
      );


    const secondary =
      this.pickColor(
        rawSecondary,
        this.DEFAULT_SECONDARY
      );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-primary',
      primary,
      RendererStyleFlags2.DashCase |
      RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-primary-focus-shadow',
      this.hexToRgba(
        primary,
        0.18
      ),
      RendererStyleFlags2.DashCase |
      RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-secondary',
      secondary,
      RendererStyleFlags2.DashCase |
      RendererStyleFlags2.Important
    );

  }


  // =========================================================
  // PAGE INFO
  // =========================================================

  async observerPageInfo(): Promise<void> {

    while (true) {

      try {

        this.domainInfo =
          this.encriptacionService
            .getPageInfo();


        this.colors =
          this.domainInfo?.colores || [];


        this.applyThemeFromDomain();

      } catch (error) {

        console.log(
          'error',
          error
        );

      }


      if (
        this.domainInfo &&
        this.domainInfo.cus_url_phone
      ) {
        break;
      }


      await this.generalService.sleep(
        2000
      );

    }

  }


  // =========================================================
  // LOGIN
  // =========================================================

  ingresar = (
    forma: NgForm
  ) => {

    if (forma.invalid) {
      return;
    }


    this.mostrarModal(
      this.trigLoginLoadingModal
    );


    this.recaptchaV3Service
      .execute('recaptcha')
      .subscribe(
        (
          token_recaptcha: string
        ) => {

          this.token_recaptcha =
            token_recaptcha;


          this._usuarioSerice
            .login(
              forma.value.rut,
              forma.value.password,
              this.recuerdame,
              this.id_typ_user,
              this.token_recaptcha
            )

            // =================================================
            // LOGIN CORRECTO
            // =================================================

            .then((resp: any) => {

              sessionStorage.setItem(
                'zoom_up_med',
                'false'
              );

              sessionStorage.setItem(
                'zoom_ud_video',
                'false'
              );


              if (
                resp.status === false
              ) {

                Swal.fire({
                  allowOutsideClick: false,

                  html: `
                    <div
                      style="
                        text-align:center;
                        padding:10px;
                        max-width:100%;
                        word-wrap:break-word;
                      "
                    >

                      <i
                        class="material-icons"
                        style="
                          color:var(--am-primary,#171994);
                          font-size:48px;
                          margin:10px auto;
                          display:block;
                        "
                      >
                        error_outline
                      </i>

                      <h1
                        style="
                          font-family:Mulish,sans-serif;
                          font-weight:600;
                          font-size:20px;
                          line-height:1.4;
                          margin-bottom:8px;
                        "
                      >
                        ${resp.title}
                      </h1>

                      <h1
                        style="
                          font-family:Mulish,sans-serif;
                          font-weight:600;
                          font-size:18px;
                          line-height:1.2;
                          color:#555;
                        "
                      >
                        ${resp.subtitle}
                      </h1>

                    </div>
                  `,

                  showConfirmButton: true

                });

                return;
              }


              if (
                resp.statusToken2FA === false
              ) {

                forma.reset();

                this.abrirModalVerificacion(
                  resp
                );

                return;
              }


              this.handleRedirection(
                resp
              );

            })


            // =================================================
            // ERROR LOGIN
            // =================================================

            .catch(
              (
                error: any
              ) => {

                console.error(
                  'Error login:',
                  error
                );


                forma.reset();


               const backendError = error?.error || {};

this.loginError.emit({
  ok: backendError?.ok ?? false,

  message:
    backendError?.message ||
    'Lo sentimos, la información que ingresaste es incorrecta.',

  url:
    backendError?.url || '',

  cusName:
    backendError?.cusName || ''
});


                /*
                 * Esperamos un ciclo para que Angular
                 * entregue errorData al componente
                 * <app-login-error>.
                 */
                setTimeout(() => {

                  this.mostrarModal(
                    this.trigLoginErrorModal
                  );

                }, 0);

              }
            )


            // =================================================
            // FIN
            // =================================================

            .finally(() => {

              this.ocultarModal(
                this.trigLoginLoadingModal
              );

            });

        }
      );

  };


  // =========================================================
  // 2FA
  // =========================================================

  abrirModalVerificacion(
    data: any
  ) {

    const dialogRef =
      this.dialog.open(
        LoginVerificationComponent,
        {
          data
        }
      );


    dialogRef
      .afterClosed()
      .subscribe(
        (
          result
        ) => {

          if (
            result &&
            result.status === true
          ) {

            this.handleRedirection(
              result
            );

          }

        }
      );

  }


  // =========================================================
  // REDIRECCIÓN LOGIN
  // =========================================================

  async handleRedirection(
    resp: any
  ) {

    this.pageLoader.show();


    try {

      const requiresOnboarding =
        !resp.use_onboarding;

      const requiresOnboardingInfo =
        !resp.use_datos_completed;

      const requiresOnboardingPass =
        resp.use_password_default;


      const route =
        resp.use_typ_id === 1
          ? 'onboarding/medico'
          : resp.use_typ_id === 2
            ? 'onboarding/paciente'
            : 'dashboard';


      if (
        requiresOnboarding ||
        requiresOnboardingInfo ||
        requiresOnboardingPass
      ) {

        await this.router.navigate([
          route
        ]);


        this.pageLoader.hide();

        return;
      }


      await this.router.navigate([
        'dashboard'
      ]);


      this.pageLoader.hide();

    } catch (error) {

      console.log(
        'Error redireccionando:',
        error
      );


      this.pageLoader.hide();

    }

  }


  // =========================================================
  // MODALS
  // =========================================================

  mostrarModal(
    modalRef: ElementRef
  ): void {

    this.renderer
      .selectRootElement(
        modalRef.nativeElement
      )
      .click();

  }


  ocultarModal(
    modalRef: ElementRef
  ): void {

    this.renderer
      .selectRootElement(
        modalRef.nativeElement
      )
      .click();

  }


  // =========================================================
  // UI
  // =========================================================

  toggleFieldTextType = () => {

    this.fieldTextType =
      !this.fieldTextType;

  };


  changeRut() {

    const valor =
      this.rut;


    if (!valor) {
      return;
    }


    const resultado =
      valor
        .split('.')
        .join('');


    const resultado2 =
      resultado
        .split('-')
        .join('');


    const cuerpo =
      resultado2
        .toString()
        .slice(
          0,
          -1
        );


    let dv: any =
      resultado2
        .toString()
        .slice(-1)
        .toUpperCase();


    this.rut =
      cuerpo +
      '-' +
      dv;


    let suma = 0;

    let multiplo = 2;


    for (
      let i = 1;
      i <= cuerpo.length;
      i++
    ) {

      const index =
        multiplo *
        Number(
          resultado2
            .toString()
            .charAt(
              cuerpo.length - i
            )
        );


      suma += index;


      multiplo =
        multiplo < 7
          ? multiplo + 1
          : 2;

    }


    const dvEsperado =
      11 -
      (
        suma %
        11
      );


    dv =
      dv === 'K'
        ? 10
        : dv;


    dv =
      dv === 0
        ? 11
        : dv;

  }

}